export default function getResource(label, vars = []) {
    const resources = {
        description: 'Désolé, cette vitrine n’est pas encore disponible. Veuillez revenir plus tard. Découvrez des essentiels beauté chez Sephora entretemps.',
        ctaText: 'Magasiner'
    };

    return resources[label];
}
